<template>
  <q-item
    clickable
    :active="item.id === selected"
    :disable="disable"
    @click="$emit('click')"
  >
    <q-item-section>
      <q-item-label class="text-ellipsis">
        <span class="module-name q-mr-sm">
          <span v-if="item.code" class="text-weight-bolder">
            {{ truncateString(item.code, 10) }}
          </span>
          <span v-if="item.name" class="text-weight-medium">
            <template v-if="item.code">-</template> {{ item.name }}
          </span>
        </span>
      </q-item-label>
    </q-item-section>
    <q-item-section side class="gt-xs">
      {{ type }}
    </q-item-section>
    <q-item-section
      side
      class="text-bold"
      style="min-width: 100px;"
    >
      {{ baseUnitPriceStr(item) }}
    </q-item-section>
  </q-item>
</template>

<script>
import inventoryMixin from './mixin'

export default {
  mixins: [inventoryMixin],
  props: {
    item: {
      required: true,
      type: Object
    },
    disable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Number,
      default: null
    }
  },
  emits: ['click'],
  computed: {
    type () {
      return this.availableTypes().find(item => item.value === this.item.type).label
    }
  }
}
</script>
